export default "__VITE_ASSET__DR2QOD9n__"